import { createSelector } from 'reselect';
import { getUploadRetryableFailedFiles } from './getUploadRetryableFailedFiles';
export const areAnyUploadRetryableFailedFiles = createSelector(getUploadRetryableFailedFiles, files => files.length > 0);
//# sourceMappingURL=areAnyUploadRetryableFailedFiles.js.map